
  import {defineComponent} from "vue";

  export default defineComponent({
    name: "AppServicesPageBanner",
    props: {
      pageData: Object
    }
  })
